"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const useOnLoad_1 = __importDefault(require("../../hooks/useOnLoad"));
const ContainerRendererWrapper_1 = __importDefault(require("./components/ContainerRendererWrapper"));
const useContainerStyle_1 = __importDefault(require("../../hooks/useContainerStyle"));
const useControlEvents_1 = __importDefault(require("../../../hooks/useControlEvents"));
const useControlParentNotNewById_1 = __importDefault(require("../../../hooks/useControlParentNotNewById"));
const controlChildrenArrayToComponent_1 = __importDefault(require("../../../shared/controlChildrenArrayToComponent"));
const isContainerViewScroll = (control, parent) => {
    if (parent === null) {
        return { isScroll: false, scroll: undefined };
    }
    if (parent.tag === 'View' && control.tag === 'View') {
        const { scroll } = parent;
        if (!scroll) {
            return { isScroll: false, scroll: undefined };
        }
        const { vertical, horizontal } = scroll;
        if (vertical || horizontal) {
            return { isScroll: true, scroll };
        }
        return { isScroll: false, scroll: undefined };
    }
    return { isScroll: false, scroll: undefined };
};
const ContainerRenderer = ({ container, }) => {
    var _a;
    const parent = (0, useControlParentNotNewById_1.default)(container.id);
    const isCViewScroll = isContainerViewScroll(container, parent);
    const isInner = container.tag === 'View' && container.containerType === 'inner';
    const containerEvents = (0, react_1.useMemo)(() => {
        var _a, _b;
        if (isInner && parent && (parent === null || parent === void 0 ? void 0 : parent.events)) {
            let mergeEvents = [...(container.events || [])];
            const onScrollBeginDrag = (_a = parent === null || parent === void 0 ? void 0 : parent.events) === null || _a === void 0 ? void 0 : _a.find((parentEvnt) => (parentEvnt.type === 'onScrollBeginDrag'));
            if (onScrollBeginDrag) {
                mergeEvents = [...mergeEvents, onScrollBeginDrag];
            }
            const onScrollEndDrag = (_b = parent === null || parent === void 0 ? void 0 : parent.events) === null || _b === void 0 ? void 0 : _b.find((parentEvnt) => (parentEvnt.type === 'onScrollEndDrag'));
            if (onScrollEndDrag) {
                mergeEvents = [...mergeEvents, onScrollEndDrag];
            }
            return mergeEvents;
        }
        return container.events;
    }, [isInner, parent, container.events]);
    const events = (0, useControlEvents_1.default)(Object.assign(Object.assign({}, container), { events: containerEvents }));
    const newEvents = (0, react_1.useMemo)(() => {
        if (isInner) {
            return events;
        }
        const newEventsIn = Object.assign({}, events);
        newEventsIn === null || newEventsIn === void 0 ? true : delete newEventsIn.onScrollBeginDrag;
        newEventsIn === null || newEventsIn === void 0 ? true : delete newEventsIn.onScrollEndDrag;
        return newEventsIn;
    }, [isInner, events]);
    (0, useOnLoad_1.default)(container, newEvents);
    const hasRowDirection = container.tag === 'topNavBar' || (container.tag === 'View' && container.containerType === 'wrapper');
    let formattedContainerStyle = Object.assign({}, container.style);
    if (hasRowDirection) {
        // As a wrapper has no children wrapper
        // whe have to inject the flexDirection attribute as row so
        // the web version can have resize anchors on inner containers
        formattedContainerStyle = Object.assign(Object.assign({}, formattedContainerStyle), { flexDirection: 'row' });
    }
    if (container.tag === 'View' && container.containerType === 'inner') {
        formattedContainerStyle = Object.assign(Object.assign({}, formattedContainerStyle), { heightAuto: (_a = parent === null || parent === void 0 ? void 0 : parent.style) === null || _a === void 0 ? void 0 : _a.heightAuto });
    }
    const containerStyle = (0, useContainerStyle_1.default)(formattedContainerStyle, parent);
    return (react_1.default.createElement(ContainerRendererWrapper_1.default, { isContainerViewScroll: isCViewScroll, control: container, style: containerStyle, events: newEvents }, (0, controlChildrenArrayToComponent_1.default)(container.controls)));
};
exports.default = ContainerRenderer;
